export const BUILTIN_OP_NAMES: Record<number, string> = {
  0: 'ADD',
  1: 'AVERAGE_POOL_2D',
  2: 'CONCATENATION',
  3: 'CONV_2D',
  4: 'DEPTHWISE_CONV_2D',
  5: 'DEPTH_TO_SPACE',
  6: 'DEQUANTIZE',
  7: 'EMBEDDING_LOOKUP',
  8: 'FLOOR',
  9: 'FULLY_CONNECTED',
  10: 'HASHTABLE_LOOKUP',
  11: 'L2_NORMALIZATION',
  12: 'L2_POOL_2D',
  13: 'LOCAL_RESPONSE_NORMALIZATION',
  14: 'LOGISTIC',
  15: 'LSH_PROJECTION',
  16: 'LSTM',
  17: 'MAX_POOL_2D',
  18: 'MUL',
  19: 'RELU',
  20: 'RELU_N1_TO_1',
  21: 'RELU6',
  22: 'RESHAPE',
  23: 'RESIZE_BILINEAR',
  24: 'RNN',
  25: 'SOFTMAX',
  26: 'SPACE_TO_DEPTH',
  27: 'SVDF',
  28: 'TANH',
  29: 'CONCAT_EMBEDDINGS',
  30: 'SKIP_GRAM',
  31: 'CALL',
  32: 'CUSTOM',
  33: 'EMBEDDING_LOOKUP_SPARSE',
  34: 'PAD',
  35: 'UNIDIRECTIONAL_SEQUENCE_RNN',
  36: 'GATHER',
  37: 'BATCH_TO_SPACE_ND',
  38: 'SPACE_TO_BATCH_ND',
  39: 'TRANSPOSE',
  40: 'MEAN',
  41: 'SUB',
  42: 'DIV',
  43: 'SQUEEZE',
  44: 'UNIDIRECTIONAL_SEQUENCE_LSTM',
  45: 'STRIDED_SLICE',
  46: 'BIDIRECTIONAL_SEQUENCE_RNN',
  47: 'EXP',
  48: 'TOPK_V2',
  49: 'SPLIT',
  50: 'LOG_SOFTMAX',
  51: 'DELEGATE',
  52: 'BIDIRECTIONAL_SEQUENCE_LSTM',
  53: 'CAST',
  54: 'PRELU',
  55: 'MAXIMUM',
  56: 'ARG_MAX',
  57: 'MINIMUM',
  58: 'LESS',
  59: 'NEG',
  60: 'PADV2',
  61: 'GREATER',
  62: 'GREATER_EQUAL',
  63: 'LESS_EQUAL',
  64: 'SELECT',
  65: 'SLICE',
  66: 'SIN',
  67: 'TRANSPOSE_CONV',
  68: 'SPARSE_TO_DENSE',
  69: 'TILE',
  70: 'EXPAND_DIMS',
  71: 'EQUAL',
  72: 'NOT_EQUAL',
  73: 'LOG',
  74: 'SUM',
  75: 'SQRT',
  76: 'RSQRT',
  77: 'SHAPE',
  78: 'POW',
  79: 'ARG_MIN',
  80: 'FAKE_QUANT',
  81: 'REDUCE_PROD',
  82: 'REDUCE_MAX',
  83: 'PACK',
  84: 'LOGICAL_OR',
  85: 'ONE_HOT',
  86: 'LOGICAL_AND',
  87: 'LOGICAL_NOT',
  88: 'UNPACK',
  89: 'REDUCE_MIN',
  90: 'FLOOR_DIV',
  91: 'REDUCE_ANY',
  92: 'SQUARE',
  93: 'ZEROS_LIKE',
  94: 'FILL',
  95: 'FLOOR_MOD',
  96: 'RANGE',
  97: 'RESIZE_NEAREST_NEIGHBOR',
  98: 'LEAKY_RELU',
  99: 'SQUARED_DIFFERENCE',
  100: 'MIRROR_PAD',
  101: 'ABS',
  102: 'SPLIT_V',
  103: 'UNIQUE',
  104: 'CEIL',
  105: 'REVERSE_V2',
  106: 'ADD_N',
  107: 'GATHER_ND',
  108: 'COS',
  109: 'WHERE',
  110: 'RANK',
  111: 'ELU',
  112: 'REVERSE_SEQUENCE',
  113: 'MATRIX_DIAG',
  114: 'QUANTIZE',
  115: 'MATRIX_SET_DIAG',
  116: 'ROUND',
  117: 'HARD_SWISH',
  118: 'IF',
  119: 'WHILE',
  120: 'NON_MAX_SUPPRESSION_V4',
  121: 'NON_MAX_SUPPRESSION_V5',
  122: 'SCATTER_ND',
  123: 'SELECT_V2',
  124: 'DENSIFY',
  125: 'SEGMENT_SUM',
  126: 'BATCH_MATMUL',
  127: 'PLACEHOLDER_FOR_GREATER_OP_CODES',
  128: 'CUMSUM',
  129: 'CALL_ONCE',
  130: 'BROADCAST_TO',
  131: 'RFFT2D',
  132: 'CONV_3D',
  133: 'IMAG',
  134: 'REAL',
  135: 'COMPLEX_ABS',
  136: 'HASHTABLE',
  137: 'HASHTABLE_FIND',
  138: 'HASHTABLE_IMPORT',
  139: 'HASHTABLE_SIZE',
  140: 'REDUCE_ALL',
  141: 'CONV_3D_TRANSPOSE',
  142: 'VAR_HANDLE',
  143: 'READ_VARIABLE',
  144: 'ASSIGN_VARIABLE',
  145: 'BROADCAST_ARGS',
  146: 'RANDOM_STANDARD_NORMAL',
  147: 'BUCKETIZE',
  148: 'RANDOM_UNIFORM',
  149: 'MULTINOMIAL',
  150: 'GELU',
  151: 'DYNAMIC_UPDATE_SLICE',
  152: 'RELU_0_TO_1',
  153: 'UNSORTED_SEGMENT_PROD',
  154: 'UNSORTED_SEGMENT_MAX',
  155: 'UNSORTED_SEGMENT_SUM',
  156: 'ATAN2',
  157: 'UNSORTED_SEGMENT_MIN',
  158: 'SIGN',
  159: 'BITCAST',
  160: 'BITWISE_XOR',
  161: 'RIGHT_SHIFT',
  162: 'STABLEHLO_LOGISTIC',
  163: 'STABLEHLO_ADD',
  164: 'STABLEHLO_DIVIDE',
  165: 'STABLEHLO_MULTIPLY',
  166: 'STABLEHLO_MAXIMUM',
  167: 'STABLEHLO_RESHAPE',
  168: 'STABLEHLO_CLAMP',
  169: 'STABLEHLO_CONCATENATE',
  170: 'STABLEHLO_BROADCAST_IN_DIM',
  171: 'STABLEHLO_CONVOLUTION',
  172: 'STABLEHLO_SLICE',
  173: 'STABLEHLO_CUSTOM_CALL',
  174: 'STABLEHLO_REDUCE',
  175: 'STABLEHLO_ABS',
  176: 'STABLEHLO_AND',
  177: 'STABLEHLO_COSINE',
  178: 'STABLEHLO_EXPONENTIAL',
  179: 'STABLEHLO_FLOOR',
  180: 'STABLEHLO_LOG',
  181: 'STABLEHLO_MINIMUM',
  182: 'STABLEHLO_NEGATE',
  183: 'STABLEHLO_OR',
  184: 'STABLEHLO_POWER',
  185: 'STABLEHLO_REMAINDER',
  186: 'STABLEHLO_RSQRT',
  187: 'STABLEHLO_SELECT',
  188: 'STABLEHLO_SUBTRACT',
  189: 'STABLEHLO_TANH',
  190: 'STABLEHLO_SCATTER',
  191: 'STABLEHLO_COMPARE',
  192: 'STABLEHLO_CONVERT',
  193: 'STABLEHLO_DYNAMIC_SLICE',
  194: 'STABLEHLO_DYNAMIC_UPDATE_SLICE',
  195: 'STABLEHLO_PAD',
  196: 'STABLEHLO_IOTA',
  197: 'STABLEHLO_DOT_GENERAL',
  198: 'STABLEHLO_REDUCE_WINDOW',
};
